import BlogApi, { BlogConfig, BlogReducer } from './blog';
import FirebaseApi, { FirebaseConfig, FirebaseReducer } from './firebase';
import GlobalConfigApi, { GlobalConfigConfig, GlobalConfigReducer } from './globalConfig';
import LoginApi, { LoginConfig, LoginReducer } from './login';
import UserApi, { UserConfig, UserReducer } from './user';

const modules = {
    [FirebaseConfig.sliceName]: {
        reducer: FirebaseReducer,
        class: FirebaseApi
    },
    [BlogConfig.sliceName]: {
        reducer: BlogReducer,
        class: BlogApi
    },
    [GlobalConfigConfig.sliceName]: {
        reducer: GlobalConfigReducer,
        class: GlobalConfigApi
    },
    [LoginConfig.sliceName]: {
        reducer: LoginReducer,
        class: LoginApi
    },
    [UserConfig.sliceName]: {
        reducer: UserReducer,
        class: UserApi
    }
};
export default modules;
